<template>
  <el-card>
    <el-descriptions>
      <el-descriptions-item :span="3" :label="$t('标题')">{{ detailInfo.name || "" }}</el-descriptions-item>
      <el-descriptions-item :span="3" :label="$t('内容')">

        <el-collapse class="collapse" v-model="activeName" >
          <template v-if="detailInfo.list.length">

            <el-collapse-item v-for="l1 in detailInfo.list" :key="l1.code" :title="l1.name" :name="l1.code">

              <template v-if="l1.children.length">
                <el-collapse class="indent">
                  <el-collapse-item v-for="l2 in l1.children" :key="l2.code" :title="l2.name" :name="l2.code">
                    <div class="content" v-html="l2.content"></div>
                  </el-collapse-item>
                </el-collapse>
              </template>

              <div class="content" v-else v-html="l1.content"></div>
            </el-collapse-item>
          </template>

          <el-collapse-item v-else :title="detailInfo.name" :name="detailInfo.code">
            <div class="content" v-html="detailInfo.content"></div>
          </el-collapse-item>
        </el-collapse>
      </el-descriptions-item>
    </el-descriptions>
  </el-card>
</template>

<script>
import {request} from "@/config/request";

export default {
  name: "FAQDetail",
  data() {
    return {
      detailInfo: {
        list: []
      },
      activeName: null,


    }
  },
  methods: {
    async loadDetail() {
      try {
        const res = await request(this.$api.questionSort.check, this.$route.query);
        this.detailInfo = this.buildTree(res.questionSort);
      } catch (e) {
        console.log(e);
      }
    },

    buildTree(target) {
      const list = [];
      // 创建 map 标识
      const nodeMap = new Map();
      target.subMapList.forEach(item => {
        item.children = [];
        nodeMap.set(item.code, item);
      })

      // 创建树形结构
      target.subMapList.forEach(item => {
        let targetItem = nodeMap.get(item.parentCode);
        if(!targetItem) {
          list.push(item);
        } else {
          targetItem.children.push(item);
        }
      })

      return {
        ...target,
        list
      }
    }

  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>

.content {
  width: 800px;
  max-height: 500px;
  overflow-y: auto;
}

.collapse {
  width: 800px;
  border: 1px solid #dddddd;
  box-sizing: border-box;
  padding: 8px;
  border-radius: 6px;
}

.indent {
  padding-left: 30px;
}


</style>
